import PropTypes from "prop-types";

export const eventShape = {
  date: PropTypes.string.isRequired,
  dateObj: PropTypes.object,
  body: PropTypes.node.isRequired,
  image: PropTypes.string,
  imageDefault: PropTypes.string,
  imageRetina: PropTypes.string,
  credit: PropTypes.string,
  alt: PropTypes.string,
};

export const eventListShape = {
  events: PropTypes.arrayOf(PropTypes.exact(eventShape).isRequired).isRequired,
  active: PropTypes.number.isRequired,
  onUpdate: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};
